/**
 * Az angular saját $parsers -eket állítbe a number típusú inputokra. Floatá parsolja, aminek következtében,
 * nem lehet beírni ilyen számot: 00123, mert levágja az elejéről a 0-ákat. Ezért törli a direktíva a default angular parserseket.
 */
export default [
	function () {
		function link(scope, $elem, attr, ngModelCtrl) {
			ngModelCtrl.$parsers = [];
		}

		return {
			require: 'ngModel',
			restrict: 'A',
			link: link
		};
	}
];
